const initials = (name = "") =>
  name.trim().split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase() || "U";

export function UserAvatar({ user, className = "", testid }) {
  if (user?.avatar_url) {
    return <img src={user.avatar_url} alt="Photo de profil" data-testid={testid} className={`object-cover ${className}`} />;
  }
  return (
    <span data-testid={testid} className={`flex items-center justify-center ${className}`}>{initials(user?.name)}</span>
  );
}
